// extracted by mini-css-extract-plugin
export default {"FullWidthButton":"RWZGiNE2zDcJs4PHjXi0"};